import React, { Component } from 'react';
import PT from 'prop-types';
import { assign } from 'lodash';

import { ReactFormFieldOneOfInput } from './reactformfieldoneofinput';
import { ReactFormFieldEmailInput } from './reactformfieldemailinput';
import { ReactFormFieldDateCombos } from './reactformfielddatecombos';
import { ReactFormFieldTextInput } from './reactformfieldtextinput';
import { ReactFormMultipleItems } from './reactformmultipleitems';
import { ReactFormMultipleDocuments } from './reactformmultipledocuments';
import { ReactFormFieldMultiline } from './reactformfieldmultiline';
import { ReactFormFieldBool } from './reactformfieldbool';
import { ReactFormFieldTags } from './reactformfieldtags';
import { ReactFormJson } from './reactformjson';

export class ReactFormField extends Component {
    constructor(props) {
        super(props);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleSubFieldChange = this.handleSubFieldChange.bind(this);
        this.handleFieldOrSubFieldChange = this.handleFieldOrSubFieldChange.bind(this);
    }

    handleFieldOrSubFieldChange(newFieldValue, subField) {
        if (this.props.onFieldOrSubFieldChange)
            this.props.onFieldOrSubFieldChange({ name: this.props.name, value: newFieldValue }, subField);
    }

    handleValueChange(newVal) {
        if(this.props.onChange)
            this.props.onChange(this.props.name, newVal);
    }

    handleSubFieldChange(subFieldName, newVal) {
        if(this.props.onChange)
            this.props.onChange(subFieldName, newVal);
    }

    getInputControlByType(type, props) {
        if(type === "ONEOF") {
            return <ReactFormFieldOneOfInput {...props} />;
        } else if(type === "EMAIL") {
            return <ReactFormFieldEmailInput {...props} />;
        } else if(type === "MULTILINE") {
            return <ReactFormFieldMultiline {...props} />;
        } else if(type === "BOOL") {
            return <ReactFormFieldBool {...props} />;
        } else if(type === "BIRTHDATE") {
            return <ReactFormFieldDateCombos {...props} showAge={true} />;
        } else if(type === "MULTIPLE_VALUES") {
            return <ReactFormMultipleItems {...props} />;
        } else if(type === "MULTIPLE_DOCUMENTS") {
            return <ReactFormMultipleDocuments {...props} indentation={this.props.indentation}/>;
        } else if(type === "TAGS") {
            return <ReactFormFieldTags {...props} />;
        } else if(type === "JSON") {
            return <ReactFormJson {...props} />;
        } else {
            return <ReactFormFieldTextInput {...props} />;
        }
    }
    render() {
        const ctl = this.getInputControlByType(
            this.props.field.type,             
            assign({},this.props.field,
            {
                value: this.props.value, 
                onChange: this.handleValueChange,
                readOnly: this.props.readOnly,
                validationErrors: this.props.validationErrors, 
                showValidationErrors: this.props.showValidationErrors && (this.props.validationErrors != null && this.props.validationErrors.length > 0),
                helpText: this.props.field.helpText,
                viewProvider: this.props.viewProvider,
                validator: this.props.validator,
                lang: this.props.lang,
                subFields: this.props.subFields,
                onSubFieldChange: this.handleSubFieldChange,
                onFieldOrSubFieldChange: this.handleFieldOrSubFieldChange
            })
        );

        return ctl;
    }
}

ReactFormField.propTypes = {
    field: PT.shape({
        type: PT.oneOf([
            "STRING",
            "INT",
            "DECIMAL",
            "BIRTHDATE",
            "EMAIL",
            "POSTALCODE",
            "BOOL",
            "TAGS",
            "MULTILINE",
            "ONEOF",
            "MULTIPLE_VALUES",
            "MULTIPLE_DOCUMENTS",
            "JSON" // Enum
        ]),
        name: PT.string,
        label: PT.oneOfType([PT.string, PT.shape({ fr: PT.string, en: PT.string })]),
        isRequired: PT.bool,
        editable: PT.bool,
        autoFillField: PT.string,
        regexExcel: PT.string,
        helpText: PT.string
    }), // Put the basic shape here
    value: PT.any,
    readOnly: PT.bool,
    onChange: PT.func,
    showValidationErrors: PT.bool,
    validationErrors: PT.array,
    validator: PT.func,
    name: PT.string,
    indentation: PT.number,
    viewProvider: PT.object,
    isMultilingual: PT.bool,
    lang: PT.string,
    subFields: PT.array, // basically, it's an array of ReactFormField
    onFieldOrSubFieldChange: PT.func
};

ReactFormField.defaultProps = {
    validationErrors: []
};
